import React, { forwardRef } from "react";
import "./FloatingInput.scss";

const FloatingInput = forwardRef(
  (
    {
      type = "text",
      label = "Label",
      id,
      error,
      className,
      required = false,
      labelClassName,
      ...rest
    },
    ref
  ) => {
    const inputClasses = [
      "form-control",
      "floating-input",
      className,
      error ? "is-invalid" : "",
    ]
      .filter(Boolean)
      .join(" ");

    const labelClasses = ["floating-label", labelClassName]
      .filter(Boolean)
      .join(" ");

    // Create input props conditionally
    const inputProps = {
      type,
      className: inputClasses,
      id,
      placeholder: " ",
      ...rest,
    };

    // Only add ref if it exists
    if (ref) {
      inputProps.ref = ref;
    }

    return (
      <div className="floating-input-wrapper position-relative w-100 mb-6">
        <input {...inputProps} />
        <label className={labelClasses} htmlFor={id}>
          {label}
          {required && <span className="text-danger"> *</span>}
        </label>

        {error && <div className="invalid-feedback ms-1 mt-0">{error}</div>}
      </div>
    );
  }
);

FloatingInput.displayName = "FloatingInput";

export default FloatingInput;
